module.exports = __webpack_public_path__ + "media/images/header__bg-aff14e869d682cdcc4849588af79675a.jpg";